// extracted by mini-css-extract-plugin
export default {"container":"MessageDayDivider_container__jRLvQ","label":"MessageDayDivider_label__JYboY"};